module.exports = __webpack_public_path__ + "img/contact.0e9b705f.jpeg";